/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import CrumbsService from 'cio/services/crumbs';
import DocsSearchService from 'cio/services/docs-search';
import { task } from 'ember-concurrency';
import type { Result } from 'cio/services/docs-search';

interface ContextualHelpArgs {
  onItemClick?: (result: Result) => unknown;
}

const SUGGESTIONS_QUANTITY = 4;

export default class ContextualHelp extends Component<ContextualHelpArgs> {
  @service crumbs!: CrumbsService;
  @service docsSearch!: DocsSearchService;

  constructor(owner: unknown, args: ContextualHelpArgs) {
    super(owner, args);

    this.fetchDocs.perform();
  }

  fetchDocs = task({ keepLatest: true }, async () => {
    let { helpQuery } = this.crumbs;

    if (helpQuery == null || helpQuery.trim() === '') {
      return [];
    }

    let results = await this.docsSearch.search.perform(helpQuery, {
      hitsPerPage: SUGGESTIONS_QUANTITY,
      ignorePlurals: true,
      removeWordsIfNoResults: 'allOptional',
    });

    return results;
  });

  get suggestionsQuantity() {
    return SUGGESTIONS_QUANTITY;
  }
}
